import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=48f372da&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=ts"
export * from "./calendar.vue?vue&type=script&lang=ts"
import style0 from "./calendar.vue?vue&type=style&index=0&id=48f372da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f372da",
  null
  
)

export default component.exports